var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentName,_vm._b({tag:"component",attrs:{"certificateStatus":_vm.certificateStatus}},'component',_vm.card,false))
}
var staticRenderFns = []

export { render, staticRenderFns }